import { render, staticRenderFns } from "./ContractActs.vue?vue&type=template&id=8354543a"
import script from "./ContractActs.vue?vue&type=script&lang=js"
export * from "./ContractActs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports